import { getStore } from '../store/zoomStore';
import { ZOOM_INCREMENTS } from './constants';

// Values returned are based on index store values in owa-custom-zoom.
export default function getCurrentZoomScale(): number {
    return ZOOM_INCREMENTS[getStore().zoomIncrementIndex];
}
